/* Checkpoint Mol — productrij (19-10-2026): pijltjes schuiven de rij, status van de pijltjes volgt de scrollpositie */
(function () {
  if (window.customElements.get('checkpoint-product-row')) return;
  class CheckpointProductRow extends HTMLElement {
    connectedCallback() {
      if (this.cpReady) return;
      this.cpReady = true;
      var self = this;
      this.track = this.querySelector('[data-cp-track]');
      this.prev = this.querySelector('[data-cp-prev]');
      this.next = this.querySelector('[data-cp-next]');
      if (!this.track) return;
      var step = function () {
        var item = self.track.querySelector('.cp-row__item');
        if (!item) return self.track.clientWidth * 0.9;
        var gap = parseFloat(getComputedStyle(self.track).columnGap || getComputedStyle(self.track).gap) || 0;
        var per = Math.max(1, Math.floor((self.track.clientWidth + gap) / (item.offsetWidth + gap)));
        return per * (item.offsetWidth + gap);
      };
      var update = function () {
        var max = self.track.scrollWidth - self.track.clientWidth;
        if (self.prev) self.prev.disabled = self.track.scrollLeft <= 2;
        if (self.next) self.next.disabled = self.track.scrollLeft >= max - 2;
        self.classList.toggle('cp-row--no-scroll', max <= 2);
      };
      if (this.prev) this.prev.addEventListener('click', function (e) { e.preventDefault(); self.track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (this.next) this.next.addEventListener('click', function (e) { e.preventDefault(); self.track.scrollBy({ left: step(), behavior: 'smooth' }); });
      this.track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(this.track);
      update();
      window.setTimeout(update, 400);
    }
  }
  window.customElements.define('checkpoint-product-row', CheckpointProductRow);
})();
